import { styled } from '../../../config'
import { TextInput } from '../../TextInput'

const Root = styled(TextInput, {
  paddingLeft: '40px',
  paddingRight: '40px',
  textAlign: 'center',
  width: 'inherit',
  variants: {
    round: {
      true: {
        borderRadius: '$round'
      }
    }
  }
})

export const InputPrimitive = {
  Root
}
